export enum ErrorCode {
    SERVER_ERROR = 400,
    MISSING_QUERY_PARAMS = 403,
    RESTAURANT_NOT_FOUND = 404,
}
